module.exports = __webpack_public_path__ + "static/media/isoright.7cab982f.JPG";